import { AggregationFunction } from "@multiweb/clients/dataReader";
import { CLEAR, INIT, SET_RESULT } from "./constants";
import { IClearAction, IInitAction, IResultAction } from "./types";

/**
 * Inicializuje reportovací komponentu se zadaným klíčem
 * @param dataKey Klíč reportovací komponenty sloužící k její jednoznačné identifikaci
 * @param className Jméno třídy, nad kterou se provádí zjištění agregované hodnoty
 * @param attrName Jméno atributu, ze kterého se bude zjišťovat hodnota
 * @param aggregationFunction Agregační funkce
 * @param condition Podmínka pro omezení dat
 * @param conditionParams Parametry podmínky
 * @param displayFormat Formátovací řetězec pro zformátování načtené hodnoty
 * @param formatProviderKey Název funkce provádějící formátování výsledné hodnoty
 * @param interactive Příznak, zda je komponenta interactivní
 * @param instanceId Id instance aktuálního objektu
 * @param methodName Statická metoda pro načtení dat
 * @returns
 */
export const createInitAction = (
    aggregationFunction: AggregationFunction,
    attrName: string,
    className: string,
    condition: string,
    dataKey: string,
    displayFormat: string,
    formatProviderKey: string,
    conditionParams?: string[],
    instanceId?: string,
    methodName?: string,
): IInitAction => ({
    type: INIT,
    payload: {
        aggregationFunction,
        attrName,
        className,
        condition,
        conditionParams,
        displayFormat,
        formatProviderKey,
        instanceId,
        methodName,
    },
    meta: {
        dataKey,
    },
});

/**
 * Akce volaná po načtení hodnoty
 * @param dataKey Klíč záznamu
 * @param result Načtená hodnota
 */
export const createSetResultAction = (dataKey: string, result: string | undefined): IResultAction => ({
    type: SET_RESULT,
    payload: {
        result,
    },
    meta: {
        dataKey,
    },
});

/** Akce starající se o smazání instance Reporting Scalaru ze storu.
 * @param dataKey Klíč záznamu
 */
export const createClearAction = (dataKey: string): IClearAction => ({
    type: CLEAR,
    meta: {
        dataKey,
    },
});
